export default "__VITE_ASSET__$EoZjzuP__"